import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://lolcorp.co.uk';
const DEFAULT_IMAGE = `${SITE_URL}/site-logo-2.jpg`;

/**
 * Per-page SEO tags. Each route should render this once with its own
 * title/description/path so Google sees unique, correctly-canonicalized
 * pages instead of 4 pages sharing one static <head>.
 *
 * noindex: set true for pages that shouldn't be indexed (e.g. thank-you
 * pages, internal tools) - keeps them out of search without deleting them.
 */
export const SEO = ({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  noindex = false,
  jsonLd = null,
}) => {
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:site_name" content="LOLCorp PVT LTD" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};
